module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/calculator-509801c01db4fea40dea0e950125bcf4.svg";